<template>
    <div class="amf-search-box" :class="isAutocomplete ? [primitiveBaseClasses] : ''" :id="searchBoxId">
        <div class="search-box input-group">
            <label class="amf-input-label" v-if="label && $_showLabel">{{label}}</label>
            <input :disabled="disabled" v-model="searchText" @keydown="keydown" @keyup.enter="onEnterClick" type="search" :placeholder="placehold" aria-label="Search"
                :class="['form-control',{ error: hasError }]" :autofocus="autofocus" style="border-top-left-radius: 0.25rem; border-bottom-left-radius: 0.25rem;">
            <div v-if="!disabled" class="input-group-append align-middle">
                <span class="input-group-text" @click="() => startSearch(searchText)">
                    <span v-if="searchInProgress" class="fa fa-ellipsis-h" style="opacity: 0.5"></span>
                    <span v-if="!searchInProgress" class="fa fa-search"></span>
                </span>
            </div>
            <div v-if="showClearButton && !disabled" class="input-group-append align-middle">
                <span @click="clearSearch" class="input-group-text">
                    <span class="fa fa-times"></span>
                </span>
            </div>
            <div class="response" v-if="response"><div>{{response}}</div></div>
        </div>
        <div class="error-div">
            {{validationMessage}}
        </div>
        <div v-show="showResults" @keydown="keydown" @keyup.enter="onEnterClick">
            <div class="search-results">
                <div v-if="optionsComponent" :is="optionsComponent" @searchOptions="searchOptions"></div>
                <div v-for="(result, index) in results"
                        :key="result.id"
                        :class="[{ highlighted: highlightedIndex == index }, 'search-result']"
                        :id="'search-result-' + index"
                        @click="highlightedIndex = index; select()">
                    <div>
                        <span v-if="result.icon" :class="['fa', result.icon]"></span>{{result.title}}
                    </div>
                </div>
                <!-- v-hide -->
                <div class="search-result" v-if="results.length == 0">
                    No results
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Popper from "popper.js";
import $ from "jquery";
import primitiveMixin from './primitive-mixin'
import { v } from "framework";

    export default {
        mixins: [primitiveMixin],
        props: {
            label: {
                type: String,
                required: false
            },
            placehold: {
                type: String,
                default: "Search"
            },
            search: {
                type: Function,
                required: true
            },
            optionsComponent: {
                type: String,
                default: null
            },
            showClearButton: {
                type: Boolean,
                default: false
            },

            isAutocomplete: {
                type: Boolean,
                default: false
            },
            showResultAfterSelection: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                required: false,
            },
            autofocus: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                searchBoxId: "amf-search-box-" + new Date().getTime(),
                options: null,
                searchText: this.value,
                response: null,
                highlightedIndex: null,
                results: [],
                showResults: false,
                resultSelected: false,
                searchInProgress: false,
                previousSearchText: null,
                previousSearchTime: null
            }
        },
        created() {
            var self = this;
            this.debouncedSearch = _.debounce(function() {
                self.startSearch();
            }, 750);
        },
        mounted() {
            document.addEventListener('click', this.outsideClick);
            var sBox = $("#" + this.searchBoxId)[0];
            var sResults = $("#" + this.searchBoxId + " .search-results")[0];
            if (!sBox || !sResults) return;
            var popper = new Popper(sBox, sResults, {
                placement: 'bottom-start'
            });
            $($("#" + this.searchBoxId + " .search-results")[0]).show();
        },
        destroyed() {
            document.removeEventListener('click', this.outsideClick);
        },
        methods: {
            outsideClick(e) {
                if(!this.$el.contains(e.target)) {
                    this.showResults = false;
                    this.results = [];
                }
            },
            searchOptions(values) {
                this.options = values;
                this.startSearch();
            },
            onEnterClick(key) {
                if (this.showResults) {
                    if (key.key == "Enter") this.select();
                } else {
                    this.startSearch(this.searchText);
                }
            },
            showResponse(msg) {
                this.response = msg;
                setTimeout(() => { this.response = null }, 3000);
            },
            keydown(ev) {
                this.resultSelected = false;
                if (ev.key == "ArrowDown" && this.highlightedIndex < this.results.length - 1) this.highlightedIndex++;
                if (ev.key == "ArrowUp" && this.highlightedIndex > 0) this.highlightedIndex--;
                let thisResultElement = document.getElementById("#" + "search-result-" + this.highlightedIndex);
                if (thisResultElement) thisResultElement.scrollIntoView();
                if (ev.key == "Tab" && this.isAutocomplete) {
                    // console.log("amfSearchBox tab pressed in autocomplete!");
                    this.showResults = false;
                }
            },
            select() {
                let result = this.results[this.highlightedIndex];
                this.showResults = false;
                this.resultSelected = true;
                this.clearSearch();
                if (result) {
                    this.$emit("select", result);
                    if(this.isAutocomplete || this.showResultAfterSelection) this.searchText = result.title;
                }
            },
            async startSearch() {
                if (!this.searchText || this.searchText.length < 3) {
                    this.showResults = false;
                    this.results = [];
                    if (!this.searchText) this.clearSearch();

                    return;
                }

                if (this.searchInProgress) return;

                if (this.searchText == this.previousSearchText
                    && (new Date().getTime() - this.previousSearchTime.getTime()) < 3000) return;

                this.searchInProgress = true;

                this.previousSearchTime = new Date();
                this.previousSearchText = this.searchText;

                try {
                    this.results = await this.search(this.searchText, this.options);
                    this.showResults = true;
                    this.highlightedIndex = 0;
                }
                finally {
                    this.searchInProgress = false;
                }

            },
            clearSearch() {
                this.searchText = null;
                this.$emit("clear");
            }
        },
        watch: {
            value(newValue) {
                // console.log("AmfSearchBox value newValue: ", newValue);
                this.resultSelected = true;
                this.searchText = newValue;
            },
            searchText(newValue) {
                // console.log("AmfSearchBox searchText newValue: ", newValue);
                this.$emit("input", newValue);
                if (this.resultSelected) return;
                this.debouncedSearch();
            },
        },
    }
</script>

<style lang="scss" scoped>
@import "../../scss/amf-variables";
  .amf-search-box {

    input {
        //min-width: 30rem;
    }

    .input-group-append {
        cursor: pointer;
    }

    .response {
        margin-left: 1rem;
        display: flex;
        align-items: center;
    }

    .search-results {
        margin-left: 1rem;
        position: absolute;
        background-color: white;
        border-bottom: 1px solid lightgray;
        border-left: 1px solid lightgray;
        border-right: 1px solid lightgray;
        min-width: 500px;
        min-height: 200px;
        max-height: 400px;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 1000;

        .search-result {
            cursor: pointer;
            padding-left: 1rem;
            padding-right: 1rem;
            padding-bottom: 0.25rem;
            border: 1px solid transparent;
            color: black;
            .fa {
                margin-right: 1rem;
                color: gray;
            }
            &.highlighted {
                background-color: $amfBlue;
                &:hover {
                    background-color: $amfBlue;
                }
            }
            &:hover {
                border: 1px dotted lightgray;
                background-color: lighten($amfBlue, 30);
            }
        }
    }
  }

</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfSearchBox.vue